export default "__VITE_ASSET__31I_D4fl__"